// Messages for portal/developers/CreateApiKeyModal (auto-merged by lib/i18n.ts).
export const en = {
  'portal.create_api_key.title': 'Create API key',
  'portal.create_api_key.cancel': 'Cancel',
  'portal.create_api_key.create': 'Create key',
  'portal.create_api_key.intro':
    "The key is shown once on creation and scoped to your company's own data.",
  'portal.create_api_key.name': 'Name',
  'portal.create_api_key.name_placeholder': 'e.g. ERP sync',
  'portal.create_api_key.scopes': 'Scopes (read)',
}

export const zhTW = {
  'portal.create_api_key.title': '建立 API 金鑰',
  'portal.create_api_key.cancel': '取消',
  'portal.create_api_key.create': '建立金鑰',
  'portal.create_api_key.intro': '此金鑰於建立時僅顯示一次，並僅限存取貴公司自身的資料。',
  'portal.create_api_key.name': '名稱',
  'portal.create_api_key.name_placeholder': '例如：ERP 同步',
  'portal.create_api_key.scopes': '範圍（讀取）',
}
